/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  isProgramError,
  type Address,
  type SOLANA_ERROR__INSTRUCTION_ERROR__CUSTOM,
  type SolanaError,
} from '@solana/kit';
import { CPMM_MIGRATOR_PROGRAM_ADDRESS } from '../programs';

/** Unauthorized: Unauthorized */
export const CPMM_MIGRATOR_ERROR__UNAUTHORIZED = 0x1770; // 6000
/** InvalidPhase: Invalid phase */
export const CPMM_MIGRATOR_ERROR__INVALID_PHASE = 0x1771; // 6001
/** InvalidAmount: Invalid amount */
export const CPMM_MIGRATOR_ERROR__INVALID_AMOUNT = 0x1772; // 6002
/** InvalidVault: Invalid vault */
export const CPMM_MIGRATOR_ERROR__INVALID_VAULT = 0x1773; // 6003
/** InvalidMint: Invalid mint */
export const CPMM_MIGRATOR_ERROR__INVALID_MINT = 0x1774; // 6004
/** MathOverflow: Math overflow */
export const CPMM_MIGRATOR_ERROR__MATH_OVERFLOW = 0x1775; // 6005
/** InvalidConfig: Invalid config */
export const CPMM_MIGRATOR_ERROR__INVALID_CONFIG = 0x1776; // 6006
/** MinRaiseNotMet: Minimum raise not met */
export const CPMM_MIGRATOR_ERROR__MIN_RAISE_NOT_MET = 0x1777; // 6007
/** PriceFloorNotMet: Price floor not met */
export const CPMM_MIGRATOR_ERROR__PRICE_FLOOR_NOT_MET = 0x1778; // 6008
/** MissingRecipientAccount: Missing recipient account */
export const CPMM_MIGRATOR_ERROR__MISSING_RECIPIENT_ACCOUNT = 0x1779; // 6009
/** InvalidRecipientAccount: Invalid recipient account */
export const CPMM_MIGRATOR_ERROR__INVALID_RECIPIENT_ACCOUNT = 0x177a; // 6010
/** ExtraRecipientAccounts: Extra recipient accounts */
export const CPMM_MIGRATOR_ERROR__EXTRA_RECIPIENT_ACCOUNTS = 0x177b; // 6011
/** PoolAlreadyInitialized: Pool already initialized */
export const CPMM_MIGRATOR_ERROR__POOL_ALREADY_INITIALIZED = 0x177c; // 6012
/** PositionAlreadyInitialized: Position already initialized */
export const CPMM_MIGRATOR_ERROR__POSITION_ALREADY_INITIALIZED = 0x177d; // 6013
/** AlreadyMigrated: Already migrated */
export const CPMM_MIGRATOR_ERROR__ALREADY_MIGRATED = 0x177e; // 6014
/** TooManyRecipients: Too many recipients */
export const CPMM_MIGRATOR_ERROR__TOO_MANY_RECIPIENTS = 0x177f; // 6015
/** InvalidRecipient: Invalid recipient */
export const CPMM_MIGRATOR_ERROR__INVALID_RECIPIENT = 0x1780; // 6016
/** InvalidLaunch: Invalid launch */
export const CPMM_MIGRATOR_ERROR__INVALID_LAUNCH = 0x1781; // 6017
/** LaunchConfigMismatch: Launch configuration mismatch */
export const CPMM_MIGRATOR_ERROR__LAUNCH_CONFIG_MISMATCH = 0x1782; // 6018
/** InvalidPool: Invalid pool */
export const CPMM_MIGRATOR_ERROR__INVALID_POOL = 0x1784; // 6020
/** InvalidPoolAuthority: Invalid pool authority */
export const CPMM_MIGRATOR_ERROR__INVALID_POOL_AUTHORITY = 0x1785; // 6021
/** InvalidPosition: Invalid position */
export const CPMM_MIGRATOR_ERROR__INVALID_POSITION = 0x1786; // 6022
/** InvalidFee: Invalid fee */
export const CPMM_MIGRATOR_ERROR__INVALID_FEE = 0x1787; // 6023
/** InvalidHookProgram: Missing or mismatched hook program account */
export const CPMM_MIGRATOR_ERROR__INVALID_HOOK_PROGRAM = 0x1788; // 6024
/** VestingNotFunded: Vesting must be funded before migration */
export const CPMM_MIGRATOR_ERROR__VESTING_NOT_FUNDED = 0x1789; // 6025

export type CpmmMigratorError =
  | typeof CPMM_MIGRATOR_ERROR__ALREADY_MIGRATED
  | typeof CPMM_MIGRATOR_ERROR__EXTRA_RECIPIENT_ACCOUNTS
  | typeof CPMM_MIGRATOR_ERROR__INVALID_AMOUNT
  | typeof CPMM_MIGRATOR_ERROR__INVALID_CONFIG
  | typeof CPMM_MIGRATOR_ERROR__INVALID_FEE
  | typeof CPMM_MIGRATOR_ERROR__INVALID_HOOK_PROGRAM
  | typeof CPMM_MIGRATOR_ERROR__INVALID_LAUNCH
  | typeof CPMM_MIGRATOR_ERROR__INVALID_MINT
  | typeof CPMM_MIGRATOR_ERROR__INVALID_PHASE
  | typeof CPMM_MIGRATOR_ERROR__INVALID_POOL
  | typeof CPMM_MIGRATOR_ERROR__INVALID_POOL_AUTHORITY
  | typeof CPMM_MIGRATOR_ERROR__INVALID_POSITION
  | typeof CPMM_MIGRATOR_ERROR__INVALID_RECIPIENT
  | typeof CPMM_MIGRATOR_ERROR__INVALID_RECIPIENT_ACCOUNT
  | typeof CPMM_MIGRATOR_ERROR__INVALID_VAULT
  | typeof CPMM_MIGRATOR_ERROR__LAUNCH_CONFIG_MISMATCH
  | typeof CPMM_MIGRATOR_ERROR__MATH_OVERFLOW
  | typeof CPMM_MIGRATOR_ERROR__MIN_RAISE_NOT_MET
  | typeof CPMM_MIGRATOR_ERROR__MISSING_RECIPIENT_ACCOUNT
  | typeof CPMM_MIGRATOR_ERROR__POOL_ALREADY_INITIALIZED
  | typeof CPMM_MIGRATOR_ERROR__POSITION_ALREADY_INITIALIZED
  | typeof CPMM_MIGRATOR_ERROR__PRICE_FLOOR_NOT_MET
  | typeof CPMM_MIGRATOR_ERROR__TOO_MANY_RECIPIENTS
  | typeof CPMM_MIGRATOR_ERROR__UNAUTHORIZED
  | typeof CPMM_MIGRATOR_ERROR__VESTING_NOT_FUNDED;

let cpmmMigratorErrorMessages: Record<CpmmMigratorError, string> | undefined;
if (process.env.NODE_ENV !== 'production') {
  cpmmMigratorErrorMessages = {
    [CPMM_MIGRATOR_ERROR__ALREADY_MIGRATED]: `Already migrated`,
    [CPMM_MIGRATOR_ERROR__EXTRA_RECIPIENT_ACCOUNTS]: `Extra recipient accounts`,
    [CPMM_MIGRATOR_ERROR__INVALID_AMOUNT]: `Invalid amount`,
    [CPMM_MIGRATOR_ERROR__INVALID_CONFIG]: `Invalid config`,
    [CPMM_MIGRATOR_ERROR__INVALID_FEE]: `Invalid fee`,
    [CPMM_MIGRATOR_ERROR__INVALID_HOOK_PROGRAM]: `Missing or mismatched hook program account`,
    [CPMM_MIGRATOR_ERROR__INVALID_LAUNCH]: `Invalid launch`,
    [CPMM_MIGRATOR_ERROR__INVALID_MINT]: `Invalid mint`,
    [CPMM_MIGRATOR_ERROR__INVALID_PHASE]: `Invalid phase`,
    [CPMM_MIGRATOR_ERROR__INVALID_POOL]: `Invalid pool`,
    [CPMM_MIGRATOR_ERROR__INVALID_POOL_AUTHORITY]: `Invalid pool authority`,
    [CPMM_MIGRATOR_ERROR__INVALID_POSITION]: `Invalid position`,
    [CPMM_MIGRATOR_ERROR__INVALID_RECIPIENT]: `Invalid recipient`,
    [CPMM_MIGRATOR_ERROR__INVALID_RECIPIENT_ACCOUNT]: `Invalid recipient account`,
    [CPMM_MIGRATOR_ERROR__INVALID_VAULT]: `Invalid vault`,
    [CPMM_MIGRATOR_ERROR__LAUNCH_CONFIG_MISMATCH]: `Launch configuration mismatch`,
    [CPMM_MIGRATOR_ERROR__MATH_OVERFLOW]: `Math overflow`,
    [CPMM_MIGRATOR_ERROR__MIN_RAISE_NOT_MET]: `Minimum raise not met`,
    [CPMM_MIGRATOR_ERROR__MISSING_RECIPIENT_ACCOUNT]: `Missing recipient account`,
    [CPMM_MIGRATOR_ERROR__POOL_ALREADY_INITIALIZED]: `Pool already initialized`,
    [CPMM_MIGRATOR_ERROR__POSITION_ALREADY_INITIALIZED]: `Position already initialized`,
    [CPMM_MIGRATOR_ERROR__PRICE_FLOOR_NOT_MET]: `Price floor not met`,
    [CPMM_MIGRATOR_ERROR__TOO_MANY_RECIPIENTS]: `Too many recipients`,
    [CPMM_MIGRATOR_ERROR__UNAUTHORIZED]: `Unauthorized`,
    [CPMM_MIGRATOR_ERROR__VESTING_NOT_FUNDED]: `Vesting must be funded before migration`,
  };
}

export function getCpmmMigratorErrorMessage(code: CpmmMigratorError): string {
  if (process.env.NODE_ENV !== 'production') {
    return (cpmmMigratorErrorMessages as Record<CpmmMigratorError, string>)[
      code
    ];
  }

  return 'Error message not available in production bundles.';
}

export function isCpmmMigratorError<
  TProgramErrorCode extends CpmmMigratorError,
>(
  error: unknown,
  transactionMessage: {
    instructions: Record<number, { programAddress: Address }>;
  },
  code?: TProgramErrorCode,
): error is SolanaError<typeof SOLANA_ERROR__INSTRUCTION_ERROR__CUSTOM> &
  Readonly<{ context: Readonly<{ code: TProgramErrorCode }> }> {
  return isProgramError<TProgramErrorCode>(
    error,
    transactionMessage,
    CPMM_MIGRATOR_PROGRAM_ADDRESS,
    code,
  );
}
